var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 16.1896C18.5 16.7755 18.051 17.2529 17.5 17.2529H15.5V6.61998H17.5C18.051 6.61998 18.5 7.0974 18.5 7.68327V16.1896ZM2.5 16.1896V7.68327C2.5 7.0974 2.949 6.61998 3.5 6.61998H5.5V17.2529H3.5C2.949 17.2529 2.5 16.7755 2.5 16.1896ZM8.5 2.89846C8.5 2.60499 8.724 2.36682 9 2.36682H12C12.276 2.36682 12.5 2.60499 12.5 2.89846V4.4934H8.5V2.89846ZM7.5 17.2529H13.5V6.61998H7.5V17.2529ZM17.5 4.4934H14.5V2.89846C14.5 1.43325 13.378 0.240234 12 0.240234H9C7.622 0.240234 6.5 1.43325 6.5 2.89846V4.4934H3.5C1.846 4.4934 0.5 5.92459 0.5 7.68327V16.1896C0.5 17.9483 1.846 19.3795 3.5 19.3795H17.5C19.154 19.3795 20.5 17.9483 20.5 16.1896V7.68327C20.5 5.92459 19.154 4.4934 17.5 4.4934Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.901fc64a64e287f18405f6397c3d40e3.svg";
export { ForwardRef as ReactComponent };